import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=3afec48a&lang=pug"
import script from "./Draft.vue?vue&type=script&lang=js"
export * from "./Draft.vue?vue&type=script&lang=js"
import style0 from "./Draft.vue?vue&type=style&index=0&id=3afec48a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports